import { useEffect, useState } from "react";
import { useResource } from "react-request-hook";

export default function useModel(Model, method, params) {
  const [resource, getResource] = useResource(Model[method], params);

  // Internal resource loading state
  // We are using useEffect + useState so useEffects that depend on this state receive the most
  // recent loading state
  const [isLoading, setIsLoading] = useState(resource.isLoading);
  useEffect(() => {
    setIsLoading(resource.isLoading);
  }, [resource.isLoading]);

  // Internal model state
  // Sets an empty model as the default value since useResource doesn't have a default value
  const [model, setModel] = useState(new Model());
  useEffect(() => {
    if (resource.error) {
      // Set empty model on error
      setModel(new Model());
    } else {
      setModel(new Model(resource.data));
    }
  }, [Model, resource.data, resource.error, resource.isLoading]);

  return [Object.assign({}, resource, { model, isLoading }), getResource];
}
